module.exports = __webpack_public_path__ + "img/ideation-2_en.2eff711.jpg";